import { render, staticRenderFns } from "./ModalDetail.vue?vue&type=template&id=15d432ed&scoped=true&"
import script from "./ModalDetail.vue?vue&type=script&lang=js&"
export * from "./ModalDetail.vue?vue&type=script&lang=js&"
import style0 from "./ModalDetail.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./ModalDetail.vue?vue&type=style&index=1&id=15d432ed&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15d432ed",
  null
  
)

export default component.exports